import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useSeo } from '@/hooks/useSeo'

/**
 * Rendered two ways. Client-side it catches in-app navigation to a bad URL;
 * at build time scripts/prerender.mjs bakes it into `dist/404.html`, which
 * CloudFront serves with a real 404 status for any path that isn't a
 * prerendered route (see the custom_error_response blocks in terraform).
 */
export function NotFoundPage() {
  useSeo('Page Not Found', 'That page does not exist.')

  return (
    <div className="container flex max-w-3xl flex-col items-start gap-6 pb-20 pt-20">
      <p className="text-sm font-medium tracking-widest text-muted-foreground">
        404
      </p>
      <h1 className="text-3xl font-semibold tracking-tight">
        This page doesn&rsquo;t exist
      </h1>
      <p className="text-muted-foreground">
        The link may be out of date, or the page may have moved. Everything else
        is still where you left it.
      </p>
      <div className="flex flex-wrap gap-3">
        <Button asChild>
          <Link to="/">Go home</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/projects">Browse projects</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/blog">Read writing</Link>
        </Button>
      </div>
    </div>
  )
}
